module.exports = "<ion-view>\n    <ion-nav-title translate>\n        SEARCH\n    </ion-nav-title>\n\n    <ion-nav-buttons side=\"secondary\">\n        <button class=\"button button-clear button-positive\" on-tap=\"$ctrl.openSearch()\">\n            Suche\n        </button>\n    </ion-nav-buttons>\n\n    <search></search>\n</ion-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/views/search/search.html
// module id = 969
// module chunks = 0